import { AsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { withMandant } from '../../../../../shared/thunks/with-mandant/with-mandant.thunk';
import { PaginationDefaults } from '../../../../../shared/utils/pagination-defaults.util';
import { axiosInstance } from '../../../../shared/api/axios-instance';
import { createQueryParams } from '../../../../shared/utils/create-query-params/create-query-params.util';
import { Endpoints } from '../../../../shared/utils/endpoints-file.utils';
import { ReviewDto } from '../dtos/review.dto';
import { ReviewModel } from '../models/review.model';
import { mapReviewDtoToReviewModel } from '../utils/mapping/mapping.util';
import { GetReviewsPathParams } from './models/get-reviews-params.model';

export const getReviews: AsyncThunk<
  ReviewModel[],
  GetReviewsPathParams,
  Record<string, unknown>
> = withMandant<GetReviewsPathParams, ReviewModel[]>(
  Endpoints.GET_REVIEWS,
  'reviews/get-reviews',
  async ({ args, endpoint }) => {
    const queryParams = createQueryParams({
      appId: args.appId,
      ...args.filters?.header,
      size: args.filters?.pagination?.size
        ? args.filters.pagination.size
        : PaginationDefaults.size,
      offset: args.filters?.pagination?.offset
        ? args.filters.pagination.offset
        : PaginationDefaults.offset,
    });

    const { data }: AxiosResponse<ReviewDto[]> = await axiosInstance.get(
      endpoint + queryParams
    );

    return data.map(mapReviewDtoToReviewModel);
  }
);
